import { Component, computed, inject, input, output } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Authentification } from '../../Services/authentification';
import {
  InterventionEditable,
  peutSupprimerIntervention,
} from '../../Services/intervention-edition';
import { InterventionSuppressionDialog } from './intervention-suppression-dialog';

/** Action partagée par les consultations du calendrier et les bons du ticket. */
@Component({
  selector: 'app-intervention-suppression',
  template: `
    @if (autorisee()) {
      <button type="button" (click)="ouvrir($event)" (keydown)="$event.stopPropagation()">
        <span class="material-symbols-outlined" aria-hidden="true">delete</span>
        {{ edition().nature === 'bon' ? 'Supprimer le bon' : 'Supprimer la planification' }}
      </button>
    }
  `,
  styles: `
    :host {
      display: inline-flex;
    }
    button {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      min-height: 44px;
      border: 1px solid #a22626;
      border-radius: 8px;
      background: white;
      color: #9b2222;
      padding: 8px 12px;
      font: inherit;
      cursor: pointer;
    }
    button:hover {
      background: #fff1f1;
    }
    button:focus-visible {
      outline: 3px solid #15334b;
      outline-offset: 3px;
    }
    .material-symbols-outlined {
      font-size: 18px;
    }
  `,
})
export class InterventionSuppression {
  private readonly auth = inject(Authentification);
  private readonly dialog = inject(MatDialog);
  readonly edition = input.required<InterventionEditable>();
  readonly ouverture = output<MatDialogRef<InterventionSuppressionDialog, boolean>>();
  readonly autorisee = computed(() =>
    peutSupprimerIntervention(this.auth.tokenInfoSignal(), this.edition()),
  );

  ouvrir(event: Event): void {
    event.stopPropagation();
    if (
      !this.autorisee() ||
      this.dialog.getDialogById('intervention-suppression') ||
      this.dialog.getDialogById('intervention-edition')
    )
      return;
    if (event.currentTarget instanceof HTMLElement) event.currentTarget.focus();
    // Capturer l’identité confirmée : un rechargement de la liste ne doit pas changer la cible.
    const edition = this.edition();
    const reference = this.dialog.open(InterventionSuppressionDialog, {
      id: 'intervention-suppression',
      data: { ...edition, valeurs: { ...edition.valeurs } },
      width: '520px',
      maxWidth: 'calc(100vw - 24px)',
      maxHeight: 'calc(100dvh - 24px)',
      ariaLabelledBy: 'suppression-intervention-titre',
      ariaDescribedBy: 'suppression-intervention-consequences',
      autoFocus: '[data-annuler-suppression]',
      restoreFocus: true,
    });
    this.ouverture.emit(reference);
  }
}
